module.exports = __webpack_public_path__ + "img/img34.645a987e.png";